// src/components/Logo.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/logo.css';

const Logo = () => {
    return (
        <Link to="/" className="fleetify-logo">
            <span className="logo-bold">Fleet</span><span className="logo-light">ify</span>
        </Link>
    );
};

export default Logo;
